'use client'; // for server side rendering

import { forwardRef, useState, type ReactNode } from 'react';
import { Snackbar, IconButton, styled } from '@mui/material';
import { useThemeProps } from '@mui/material/styles';

export interface CopyToClipboardButtonProps {
    text?: string;
    autoHideDuration?: number;
    buttonContent?: ReactNode; // we recommend '@mui/icons-material/ContentCopy'
    children: NonNullable<ReactNode>;
}

const CopyToClipboardButtonRoot = styled(IconButton, {
    name: 'MuiCopyToClipboardButton',
    slot: 'root',
})({});

export const CopyToClipboardButton = forwardRef<HTMLButtonElement, CopyToClipboardButtonProps>(
    function CopyToClipboardButton(inProps, ref) {
        const props = useThemeProps({ props: inProps, name: 'MuiCopyToClipboardButton' });
        const { text, autoHideDuration, buttonContent, children } = props;
        const [open, setOpen] = useState(false);
        const value = text || JSON.stringify(children);
        const handleClick = () => {
            setOpen(true);
            navigator.clipboard.writeText(value);
        };

        return (
            <>
                {children}
                <CopyToClipboardButtonRoot
                    ref={ref}
                    color="primary"
                    size="small"
                    onClick={handleClick}>
                    {buttonContent || 'Copy'}
                </CopyToClipboardButtonRoot>
                <Snackbar
                    open={open}
                    onClose={() => {
                        setOpen(false);
                    }}
                    autoHideDuration={autoHideDuration || 2500}
                    message={`Copied '${value}' to clipboard`}
                />
            </>
        );
    }
);

export default CopyToClipboardButton;
